<template>
  <div class="train-com">
    <div class="train-con">
      <img v-if="TrainData && TrainData.coverMaterial" :src="TrainData && TrainData.coverMaterial.url" class="con-cover" alt="" />
      <div v-else class="con-cover"></div>
      <div class="con-info">
        {{ TrainData && TrainData.title }}
      </div>
      <div class="status status2" v-if="TrainData.status === '1'">
        {{ TrainData && TrainData.statusText }}
      </div>
      <div class="status status1" v-if="TrainData.status === '2'">
        {{ TrainData && TrainData.statusText }}
      </div>
      <div class="status status3" v-if="TrainData.status === '3'">
        {{ TrainData && TrainData.statusText }}
      </div>
      <div class="status status4" v-if="TrainData.publishStatus === '3'">
        {{ TrainData && TrainData.statusText }}
      </div>
    </div>
    <img v-if="TrainData && TrainData.livePosterMaterial" :src="TrainData && TrainData.livePosterMaterial.url" class="line-poster" alt="" />
    <div class="train-title">
      <div class="title-txt">基本信息</div>
    </div>
    <div class="train-block base-info">
      <div class="block-item">
        <div class="label">活动时间</div>
        <div class="val">
          {{ TrainData && TrainData.startTimeTxt }} -
          {{ TrainData && TrainData.endTimeTxt }}
        </div>
      </div>
      <div class="block-item">
        <div class="label">活动医院</div>
        <div class="val">{{ TrainData.hospital ? TrainData.hospital.cnName : '' }}</div>
      </div>
      <div class="block-item">
        <div class="label">活动地址</div>
        <div class="val">
          线上会议
          <div @click.stop="gotoLine(TrainData)" class="val-btn" :class="
            (TrainData.isTimeSign === 'Y' || TrainData.status === '1')
              ? 'cur'
              : ''
          ">
            进入会议
          </div>
        </div>
      </div>
      <div class="block-item">
        <div class="label">活动简介</div>
      </div>
      <div class="block-item">
        <div class="val info">
          本次会议是由{{ TrainData.hospital ? TrainData.hospital.cnName : '' }}发起的{{ TrainData.stageActivity ? TrainData.stageActivity.name : '' }},{{ TrainData && TrainData.summaryText }}
        </div>
      </div>
    </div>
    <div class="train-block block-date">
      <div class="date-title">日程</div>
      <div class="date-head">
        <div class="thead one">活动时间</div>
        <div class="thead two">活动主题</div>
        <div class="thead three">主讲人</div>
      </div>
      <div class="date-tbody" v-for="(item, index) in TrainDateList" :key="index">
        <div class="tbody-title" v-if="TrainDateList.length > 1">
          Day{{ index + 1 }}
        </div>
        <div class="tbody-item" v-for="(itm, _index) in item" :key="_index">
          <div class="thead one">
            {{ itm && itm.startTimeText }} — {{ itm && itm.endTimeText }}
          </div>
          <div class="thead two two2">{{ itm && itm.topic }}</div>
          <div class="thead three" v-if="itm.lecturers && itm.lecturers.length > 0">
            <div v-for="item2 in itm.lecturers" :key="item2.name">{{ item2 && item2.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LineZoomComponent',
  props: {
    TrainDateListArr: {
      type: Array
    },
    TrainData: {
      type: Object
    }
  },
  data () {
    return {
      TrainDateList: [],
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    TrainDateListArr (newVal) {
      this.TrainDateListArr = newVal
      this.handleBase()
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.TrainDateListArr.length > 0) {
        this.handleBase()
      }
    })
  },
  methods: {
    gotoLine (TrainData) {
      if (TrainData.status === '1') {
        window.location.href = TrainData.liveLink
      }
    },
    handleBase () {
      const datalist = Object.values(this.TrainDateListArr.reduce((respon, item) => {
        item.startTimeText = this.$moment(parseInt(item.startTime)).format('HH:mm')
        item.endTimeText = this.$moment(parseInt(item.endTime)).format('HH:mm')
        item.baseDate = this.$moment(parseInt(item.startTime)).format('YYYY-MM-DD')
        respon[item.baseDate]
          ? respon[item.baseDate].push(item)
          : (respon[item.baseDate] = [item])
        return respon
      }, {}))
      this.TrainDateList = datalist
      console.log(this.TrainDateList, 'popo')
      this.TrainData.statusText = ''
      if (this.TrainData.publishStatus === '2') {
        switch (this.TrainData.status) {
          case '1':
            this.TrainData.statusText = '进行中'
            break
          case '2':
            this.TrainData.statusText = '待开始'
            break
          case '3':
            this.TrainData.statusText = '已完成'
            break
        }
      } else if (this.TrainData.publishStatus === '3') {
        this.TrainData.statusText = '已取消'
      }
      this.TrainData.startTimeTxt = this.$moment(parseInt(this.TrainData.startTime)).format('YYYY-MM-DD HH:mm')
      this.TrainData.endTimeTxt = this.$moment(parseInt(this.TrainData.endTime)).format('MM-DD HH:mm')
    },
  }
}
</script>

<style lang="less" scoped>
.line-poster {
  width: 100%;
  display: block;
  margin-top: 8px;
}

.train-con {
  display: flex;
  padding: 16px 24px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;

  .con-cover {
    width: 118px;
    height: 70px;
    margin-right: 12px;
    border-radius: 6px;
    object-fit: cover;
    background-color: #eee;
  }

  .con-info {
    font-size: 14px;
    color: #2b2b2b;
    font-weight: 500;
    line-height: 20px;
    height: 58px;
    width: 180px;
    display: -webkit-box;
    /* 盒子类型 */
    word-break: break-all;
    /* 自动换行的处理方法。允许在单词内换行 */
    text-overflow: ellipsis;
    /* 溢出时用... */
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    /* 最大行数 */
  }

  .status {
    position: absolute;
    width: 50px;
    height: 24px;
    background-color: #EB1700;
    display: flex;
    align-items: center;
    line-height: 24px;
    justify-content: center;
    font-size: 12px;
    color: #fff;
    top: 0;
    right: 0;
    border-bottom-left-radius: 12px;

    &.status1 {
      background-color: #FF6017;
    }

    &.status2 {
      background-color: #EB1700;
    }

    &.status3 {
      background-color: #328714;
    }

    &.status4 {
      background-color: #D5CFC9;
    }
  }
}

.item-btm {
  display: flex;
  justify-content: flex-end;
  height: 40px;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    left: 50%;
    width: 340px;
    transform: translateX(-50%);
    height: 1px;
    background-color: #e0e2e7;
    content: '';
  }

  .btn-txt {
    font-size: 12px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 72px;
    height: 23px;

    &.cur {
      box-sizing: border-box;
      border: 0.5px solid #EB1700;
      background-color: #EB1700;
      border-radius: 100px;
    }
  }
}

.train-block {
  background-color: #fff;
  border-radius: 4px;
  margin: 0 12px;
  margin-bottom: 8px;

  &.base-info {
    padding: 16px 12px;
    box-sizing: border-box;

    .block-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      align-items: center;

      .label {
        color: #2b2b2b;
        line-height: 17px;
        font-size: 12px;
        font-weight: 500;
      }

      .val {
        color: #2b2b2b;
        font-size: 12px;
        width: 220px;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        &.info {
          flex: 1;
          width: 100%;
          justify-content: flex-start;
          text-align: left;
        }

        .val-btn {
          border: 1px solid #9b9b9b;
          width: 72px;
          height: 23px;
          line-height: 23px;
          text-align: center;
          font-size: 12px;
          color: #9b9b9b;
          margin-left: 8px;
          border-radius: 100px;

          &.cur {
            color: #fff;
            border-color: #EB1700;
            background-color: #EB1700;
          }
        }
      }
    }
  }

  &.block-date {
    padding: 16px 12px;
    box-sizing: border-box;

    .date-title {
      font-size: 13px;
      color: #2b2b2b;
      font-weight: 600;
      margin-bottom: 12px;
      padding-left: 6px;
      box-sizing: border-box;
    }

    .date-head {
      display: flex;
      align-items: center;
      height: 34px;
      background-color: #f0f1f6;
      font-size: 12px;
    }

    .one {
      width: 100px;
      margin-right: 14px;
      padding-left: 8px;
      text-align: left;
    }

    .two {
      width: 135px;
      text-align: left;
      &.two2 {
        max-height: 40px;
      }
    }

    .three {
      width: 80px;
      margin-left: 14px;
      padding-right: 12px;
    }

    .tbody-title {
      font-size: 12px;
      color: #2b2b2b;
      line-height: 32px;
      font-weight: 600;
      box-sizing: border-box;
      text-align: center;
      border-bottom: 1px solid #f0f1f6;
    }

    .tbody-item {
      display: flex;
      padding-bottom: 16px;
      padding-top: 10px;
      box-sizing: border-box;
      align-items: center;

      &:nth-last-child(1) {
        padding-bottom: 0;
      }

      .thead {
        font-size: 12px;
        color: #2b2b2b;
        line-height: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3; // 控制多行的行数
        -webkit-box-orient: vertical;
      }
    }
  }
}

.train-title {
  padding: 20px 0 7px 27px;

  .title-txt {
    line-height: 22px;
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    position: relative;

    &::before {
      position: absolute;
      width: 4px;
      height: 12px;
      background-color: #EB1700;
      border-radius: 4px;
      left: -10px;
      content: '';
      bottom: 4px;
    }
  }
}

::v-deep(.van-cell),
::v-deep(.van-collapse-item__content) {
  padding: 0;
}

::v-deep(.van-collapse:after) {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/xwzy/components/LineZoomComponent.vue